import { render } from "./DataTableExercises.vue?vue&type=template&id=66da5264&scoped=true&ts=true"
import script from "./DataTableExercises.vue?vue&type=script&lang=ts"
export * from "./DataTableExercises.vue?vue&type=script&lang=ts"

import "./DataTableExercises.vue?vue&type=style&index=0&id=66da5264&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66da5264"]])

export default __exports__